import React from 'react';
import Box from '@amzn/awsui-components-console/box';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import type { WorkStep as WorkStepType } from '../../types';
import './HowItWorksSection.scss';

export interface HowItWorksSectionProps {
  onManageCollections: () => void;
  onManageApplications: () => void;
}

const steps: WorkStepType[] = [
  {
    number: 1,
    title: 'Get permission',
    description: 'Contact the GCR Tech Team to obtain permission.',
  },
  {
    number: 2,
    title: 'Create Content Collection',
    description: 'Create a Content Collection within an existing Data Source.',
  },
  {
    number: 3,
    title: 'Subscribe Content Collection',
    description: 'Subscribe content collections to Applications.',
  },
];

const HowItWorksSection: React.FC<HowItWorksSectionProps> = ({ onManageCollections, onManageApplications }) => {
  return (
    <Box margin={{ top: 'xl' }}>
      <SpaceBetween size="l">
        <Box textAlign="center">
          <h2 className="section-title">How it works</h2>
        </Box>

        <div className="work-steps-grid">
          {steps.map((step, index) => (
            <div className="work-step">
              <div className={`work-step__number-wrapper ${index < steps.length - 1 ? 'with-connector' : ''}`}>
                <div className="work-step__number">{step.number}</div>
                {index < steps.length - 1 && <div className="work-step__connector"></div>}
              </div>
              <h3 className="work-step__title">{step.title}</h3>
              <p className="work-step__description">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="action-buttons">
          <button className="action-button" onClick={onManageCollections}>
            Manage Content Collections
          </button>
          <button className="action-button" onClick={onManageApplications}>
            Manage Applications
          </button>
        </div>
      </SpaceBetween>
    </Box>
  );
};

export default HowItWorksSection;
